"use strict";

// Copyright 2013 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var _asyncToGenerator = require("/home/pc/Github/MMA-Scheduler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
var _classCallCheck = require("/home/pc/Github/MMA-Scheduler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/pc/Github/MMA-Scheduler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/home/pc/Github/MMA-Scheduler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _get = require("/home/pc/Github/MMA-Scheduler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");
var _getPrototypeOf = require("/home/pc/Github/MMA-Scheduler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/home/pc/Github/MMA-Scheduler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JWT = void 0;
var gtoken_1 = require("gtoken");
var jwtaccess_1 = require("./jwtaccess");
var oauth2client_1 = require("./oauth2client");
var JWT = /*#__PURE__*/function (_oauth2client_1$OAuth) {
  _inherits(JWT, _oauth2client_1$OAuth);
  function JWT(optionsOrEmail, keyFile, key, scopes, subject, keyId) {
    var _this;
    _classCallCheck(this, JWT);
    var opts = optionsOrEmail && typeof optionsOrEmail === 'object' ? optionsOrEmail : {
      email: optionsOrEmail,
      keyFile: keyFile,
      key: key,
      keyId: keyId,
      scopes: scopes,
      subject: subject
    };
    _this = _possibleConstructorReturn(this, _getPrototypeOf(JWT).call(this, {
      eagerRefreshThresholdMillis: opts.eagerRefreshThresholdMillis,
      forceRefreshOnFailure: opts.forceRefreshOnFailure
    }));
    _this.email = opts.email;
    _this.keyFile = opts.keyFile;
    _this.key = opts.key;
    _this.keyId = opts.keyId;
    _this.scopes = opts.scopes;
    _this.subject = opts.subject;
    _this.additionalClaims = opts.additionalClaims;
    _this.credentials = {
      refresh_token: 'jwt-placeholder',
      expiry_date: 1
    };
    return _this;
  }
  /**
   * Creates a copy of the credential with the specified scopes.
   * @param scopes List of requested scopes or a single scope.
   * @return The cloned instance.
   */
  _createClass(JWT, [{
    key: "createScoped",
    value: function createScoped(scopes) {
      return new JWT({
        email: this.email,
        keyFile: this.keyFile,
        key: this.key,
        keyId: this.keyId,
        scopes: scopes,
        subject: this.subject,
        additionalClaims: this.additionalClaims
      });
    }
    /**
     * Obtains the metadata to be sent with the request.
     *
     * @param url the URI being authorized.
     */
  }, {
    key: "getRequestMetadataAsync",
    value: function () {
      var _getRequestMetadataAsync = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(url) {
        var _yield$this$refreshTo, tokens, headers;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!this.apiKey && !this.hasUserScopes() && url)) {
                _context.next = 16;
                break;
              }
              if (!(this.additionalClaims && this.additionalClaims.target_audience)) {
                _context.next = 9;
                break;
              }
              _context.next = 4;
              return this.refreshToken();
            case 4:
              _yield$this$refreshTo = _context.sent;
              tokens = _yield$this$refreshTo.tokens;
              return _context.abrupt("return", {
                headers: this.addSharedMetadataHeaders({
                  Authorization: "Bearer ".concat(tokens.id_token)
                })
              });
            case 9:
              // no scopes have been set, but a uri has been provided. Use JWTAccess
              // credentials.
              if (!this.access) {
                this.access = new jwtaccess_1.JWTAccess(this.email, this.key, this.keyId, this.eagerRefreshThresholdMillis);
              }
              _context.next = 12;
              return this.access.getRequestHeaders(url, this.additionalClaims);
            case 12:
              headers = _context.sent;
              return _context.abrupt("return", {
                headers: this.addSharedMetadataHeaders(headers)
              });
            case 14:
              _context.next = 21;
              break;
            case 16:
              if (!(this.hasAnyScopes() || this.apiKey)) {
                _context.next = 20;
                break;
              }
              return _context.abrupt("return", _get(_getPrototypeOf(JWT.prototype), "getRequestMetadataAsync", this).call(this, url));
            case 20:
              return _context.abrupt("return", {
                headers: {}
              });
            case 21:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getRequestMetadataAsync(_x) {
        return _getRequestMetadataAsync.apply(this, arguments);
      }
      return getRequestMetadataAsync;
    }()
    /**
     * Fetches an ID token.
     * @param targetAudience the audience for the fetched ID token.
     */
  }, {
    key: "fetchIdToken",
    value: function () {
      var _fetchIdToken = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(targetAudience) {
        var gtoken;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // Create a new gToken for fetching an ID token
              gtoken = new gtoken_1.GoogleToken({
                iss: this.email,
                sub: this.subject,
                scope: this.scopes || this.defaultScopes,
                keyFile: this.keyFile,
                key: this.key,
                additionalClaims: {
                  target_audience: targetAudience
                }
              });
              _context2.next = 3;
              return gtoken.getToken({
                forceRefresh: true
              });
            case 3:
              if (gtoken.idToken) {
                _context2.next = 5;
                break;
              }
              throw new Error('Unknown error: Failed to fetch ID token');
            case 5:
              return _context2.abrupt("return", gtoken.idToken);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchIdToken(_x2) {
        return _fetchIdToken.apply(this, arguments);
      }
      return fetchIdToken;
    }()
    /**
     * Determine if there are currently scopes available.
     */
  }, {
    key: "hasUserScopes",
    value: function hasUserScopes() {
      if (!this.scopes) {
        return false;
      }
      return this.scopes.length > 0;
    }
    /**
     * Are there any default or user scopes defined.
     */
  }, {
    key: "hasAnyScopes",
    value: function hasAnyScopes() {
      if (this.scopes && this.scopes.length > 0) return true;
      if (this.defaultScopes && this.defaultScopes.length > 0) return true;
      return false;
    }
  }, {
    key: "authorize",
    value: function authorize(callback) {
      if (callback) {
        this.authorizeAsync().then(function (r) {
          return callback(null, r);
        }, callback);
      } else {
        return this.authorizeAsync();
      }
    }
  }, {
    key: "authorizeAsync",
    value: function () {
      var _authorizeAsync = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var result;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.refreshToken();
            case 2:
              result = _context3.sent;
              if (result) {
                _context3.next = 5;
                break;
              }
              throw new Error('No result returned');
            case 5:
              this.credentials = result.tokens;
              this.credentials.refresh_token = 'jwt-placeholder';
              this.key = this.gtoken.key;
              this.email = this.gtoken.iss;
              return _context3.abrupt("return", result.tokens);
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function authorizeAsync() {
        return _authorizeAsync.apply(this, arguments);
      }
      return authorizeAsync;
    }()
    /**
     * Refreshes the access token.
     * @param refreshToken ignored
     * @private
     */
  }, {
    key: "refreshTokenNoCache",
    value: function () {
      var _refreshTokenNoCache = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      refreshToken) {
        var gtoken, token, tokens;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              gtoken = this.createGToken();
              _context4.next = 3;
              return gtoken.getToken({
                forceRefresh: this.isTokenExpiring()
              });
            case 3:
              token = _context4.sent;
              tokens = {
                access_token: token.access_token,
                token_type: 'Bearer',
                expiry_date: gtoken.expiresAt,
                id_token: gtoken.idToken
              };
              this.emit('tokens', tokens);
              return _context4.abrupt("return", {
                res: null,
                tokens: tokens
              });
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function refreshTokenNoCache(_x3) {
        return _refreshTokenNoCache.apply(this, arguments);
      }
      return refreshTokenNoCache;
    }()
    /**
     * Create a gToken if it doesn't already exist.
     */
  }, {
    key: "createGToken",
    value: function createGToken() {
      if (!this.gtoken) {
        this.gtoken = new gtoken_1.GoogleToken({
          iss: this.email,
          sub: this.subject,
          scope: this.scopes || this.defaultScopes,
          keyFile: this.keyFile,
          key: this.key,
          additionalClaims: this.additionalClaims
        });
      }
      return this.gtoken;
    }
    /**
     * Create a JWT credentials instance using the given input options.
     * @param json The input object.
     */
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      if (!json) {
        throw new Error('Must pass in a JSON object containing the service account auth settings.');
      }
      if (!json.client_email) {
        throw new Error('The incoming JSON object does not contain a client_email field');
      }
      if (!json.private_key) {
        throw new Error('The incoming JSON object does not contain a private_key field');
      }
      // Extract the relevant information from the json key file.
      this.email = json.client_email;
      this.key = json.private_key;
      this.keyId = json.private_key_id;
      this.projectId = json.project_id;
      this.quotaProjectId = json.quota_project_id;
    }
  }, {
    key: "fromStream",
    value: function fromStream(inputStream, callback) {
      if (callback) {
        this.fromStreamAsync(inputStream).then(function () {
          return callback();
        }, callback);
      } else {
        return this.fromStreamAsync(inputStream);
      }
    }
  }, {
    key: "fromStreamAsync",
    value: function fromStreamAsync(inputStream) {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        if (!inputStream) {
          throw new Error('Must pass in a stream containing the service account auth settings.');
        }
        var s = '';
        inputStream.setEncoding('utf8').on('error', reject).on('data', function (chunk) {
          return s += chunk;
        }).on('end', function () {
          try {
            var data = JSON.parse(s);
            _this2.fromJSON(data);
            resolve();
          } catch (e) {
            reject(e);
          }
        });
      });
    }
    /**
     * Creates a JWT credentials instance using an API Key for authentication.
     * @param apiKey The API Key in string form.
     */
  }, {
    key: "fromAPIKey",
    value: function fromAPIKey(apiKey) {
      if (typeof apiKey !== 'string') {
        throw new Error('Must provide an API Key string.');
      }
      this.apiKey = apiKey;
    }
    /**
     * Using the key or keyFile on the JWT client, obtain an object that contains
     * the key and the client email.
     */
  }, {
    key: "getCredentials",
    value: function () {
      var _getCredentials = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var gtoken, creds;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!this.key) {
                _context5.next = 4;
                break;
              }
              return _context5.abrupt("return", {
                private_key: this.key,
                client_email: this.email
              });
            case 4:
              if (!this.keyFile) {
                _context5.next = 10;
                break;
              }
              gtoken = this.createGToken();
              _context5.next = 8;
              return gtoken.getCredentials(this.keyFile);
            case 8:
              creds = _context5.sent;
              return _context5.abrupt("return", {
                private_key: creds.privateKey,
                client_email: creds.clientEmail
              });
            case 10:
              throw new Error('A key or a keyFile must be provided to getCredentials.');
            case 11:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getCredentials() {
        return _getCredentials.apply(this, arguments);
      }
      return getCredentials;
    }()
  }]);
  return JWT;
}(oauth2client_1.OAuth2Client);
exports.JWT = JWT;